import React from 'react';
import { Select, theme } from 'components';
import styled from 'styled-components';
import type { ColumnsType } from 'antd/es/table';
import type { SupraLockboxJsonType } from '@/app-package';
import { StyledTable } from '../styles';
import { LockboxPermissionType } from './types';

type LockboxDisplayProps = {
  visible?: boolean;
  unassignedLockboxes: SupraLockboxJsonType[];
  onPermissionChange: (
    lockboxId: string,
    permissionType: LockboxPermissionType,
  ) => void;
};

const AddLockboxModalDisplay: React.FC<LockboxDisplayProps> = ({
  visible,
  unassignedLockboxes,
  onPermissionChange,
}) => {
  const getLockboxType = (type: string) =>
    type === 'iBox' ? 'iBox BT LE' : 'Invoy';

  const columns: ColumnsType<any> = [
    { title: 'SERIAL #', dataIndex: 'serialNumber', key: 'serialNumber' },
    {
      title: 'TYPE',
      dataIndex: 'productCode',
      key: 'productCode',
      width: '35%',
      render: type => getLockboxType(type),
    },
    {
      title: 'PERMISSIONS',
      dataIndex: 'permissions',
      key: 'permissions',
      width: '190px',
      render: (_, { _id }) => (
          <StyledSelectPermission
            placeholder="Select Permissions"
            bordered={false}
            onChange={value => onPermissionChange(_id, value)}
            options={[
              { key: 1, value: 'owner', label: 'Owner' },
              { key: 2, value: 'assignee', label: 'Assignee' },
            ]}
          />
        ),
    },
  ];

  if (visible) {
    return (
      <StyledTable
        columns={columns}
        dataSource={unassignedLockboxes}
        pagination={false}
        scroll={{ y: 260 }}
      />
    );
  }

  return null;
};

const StyledSelectPermission = styled(Select)`
  .ant-select-selection-item {
    color: ${theme.blue6};
  }
  .ant-select-selection-placeholder {
    color: ${theme.blue6};
  }
  .anticon-down {
    color: ${theme.blue6};
  }
`;

export default AddLockboxModalDisplay;
